// extracted by mini-css-extract-plugin
export default {"main":"LevelTestAiAnswer_main__sMzXJ","inner":"LevelTestAiAnswer_inner__cftFt","section":"LevelTestAiAnswer_section__GIc9D"};